import '../scss/style.scss'

// GraphQL Test
/*import CraftData from './api/craft/craftContent'
CraftData.getEntries({section: 'news'}).then((data)=>{
  console.log('Test GraphQL Get Entries: ', data);
});*/

import isTouchDevice from 'is-touch-device'
if (isTouchDevice()) {
  document.body.classList.add('touch')
} else {
  // const cursor = new AnimateCursor();
  document.body.classList.add('not-touch')
}
